import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import Template from '../templates/template';
import TemplateImages from '../templates/template-images';

const ABout = inject("stores") (
    observer (
        class ABout extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;

                this.storeUi = this.props.stores.storeUi;
            }

            render() {
                return (
                    <Template>
                        <div class="container-content">
                            <div class="content-columns">
                                <div class="content-column">
                                <h1>About Amsterdam Labels</h1>
                                </div>
                            </div>
                            
                            <div class="content-columns">
                                <div class="content-column content-column--text">
                                    <p>Amsterdam Labels is het mode agentschap met passie voor merken waarbij duurzaamheid, kwaliteit en lokale productie belangrijk zijn.</p>
                                    <p>Ik ben altijd op zoek naar labels die aansluiten bij mijn mode filosofie: klasse is stijlvol en tijdloos.<br/>Modemerken die de zelfbewuste vrouw ondersteunen met een mooie, passende look in elk levensmoment.</p>
                                    <p>Op kantoor, in vrije tijd en tot en met de huwelijksdag selecteer ik in brands die voor elk moment de unieke stijl van de vrouw weerspiegelen. Uitgangspunten: zelfbewust, zelfverzekerd en straal.</p>
                                    <div className="content--portrait">
                                        <img className="content--portrait__image" src={this.urlAPI + "/adam/public/images/portrait-linda.jpg"} />
                                        <span className="content--portrait__subscript">Linda Boccara</span>
                                    </div>
                                </div>
                                <div class="content-column content-column--images">
                                    <img className="single-image" src={this.urlAPI + "/adam/public/images/showroom.png"} /> 
                                </div>
                            </div>
                        </div>
                    </Template>
                );
            }
        }
    )
)

export default ABout;
